/* eslint-disable eqeqeq */
import api from "Services/API";
import { ResponseMessage } from "Services/Share.props";
import {
    ConfirmUploadedOrdersBody,
    UploadOrdersExcelPathVariables,
    UploadOrdersExcelResponse,
} from "./OrdersService.props";

export const uploadExcel = ({
    date,
    vendorId,
    excelFile,
    apiType,
}: UploadOrdersExcelPathVariables) => {
    let url = `/admin/order/import/${date}/${vendorId}`;
    if (apiType === "convert") {
        url = `admin/v2/order/convert/upload/${vendorId}/${date}`;
    }
    return api.post<UploadOrdersExcelResponse>(url, excelFile);
};

export const confirmUploadedOrders = (data: ConfirmUploadedOrdersBody) => {
    return api.put<ResponseMessage>(`/admin/order/import`, data);
};

export const BackToDraft = (order_id: number) => {
    return api.post("/admin/v2/order/redraft", { order_id });
};

export const DailyOrdersList = (params: any) => {
    return api.get(`/admin/order`, { params });
};

export const DailyDryOrdersList = (params: any) => {
    return api.get(`/admin/order/dry`, { params });
};
export const DailyOfflineOrdersList = (params: any) => {
    return api.get(`/admin/order-offline`, { params });
};

export const getDailyOrdersDate = () => {
    return api.get(`/admin/week-day`);
};

export const getNewOrderParams = ({
    params,
    vendorId,
    date,
}: {
    params: any;
    vendorId: any;
    date: any;
}) => {
    return api.get(`/admin/v2/order/${vendorId}/${date}`, { params });
};

export const getLastConvertedOrderParams = ({
    params,
    vendorId,
    date,
}: {
    params: any;
    vendorId: any;
    date: any;
}) => {
    return api.get(`/admin/v2/converted-order/${vendorId}/${date}`, { params });
};

export const getNewOfflineOrderParams = ({
    params,
    vendorId,
    date,
}: {
    params: any;
    vendorId: any;
    date: any;
}) => {
    return api.get(`/admin/v2/order-offline/${vendorId}/${date}`, { params });
};

export const getDryNewOrderParams = ({
    params,
    vendorId,
    date,
}: {
    params: any;
    vendorId: any;
    date: any;
}) => {
    return api.get(`/admin/v2/order/dry/${vendorId}/${date}`, { params });
};

export const submitDraftValues = ({
    isUpdate,
    body,
}: {
    isUpdate: boolean;
    body: any;
}) => {
    if (isUpdate) {
        return api.put("/admin/v2/order", body);
    } else {
        return api.post("/admin/v2/order", body);
    }
};

export const submitDryOrdersValues = ({
    isUpdate,
    body,
}: {
    isUpdate: boolean;
    body: any;
}) => {
    if (isUpdate) {
        return api.put("/admin/v2/order/dry", body);
    } else {
        return api.post("/admin/v2/order/dry", body);
    }
};

export const submitOfflineOrdersValues = ({
    isUpdate,
    body,
}: {
    isUpdate: boolean;
    body: any;
}) => {
    if (isUpdate) {
        return api.put("/admin/v2/order-offline", body);
    } else {
        return api.post("/admin/v2/order-offline", body);
    }
};

export const getNewOrderModel = ({
    vendorId,
    params,
    date,
}: {
    params: any;
    vendorId: any;
    date: any;
}) => {
    return api.get(`/admin/v2/order-prediction/${vendorId}/${date}`, {
        params,
    });
};

export const getNewOrderConvertModel = ({
    vendorId,
    params,
    date,
}: {
    params: any;
    vendorId: any;
    date: any;
}) => {
    return api.get(`/admin/v2/order-prediction-convert/${vendorId}/${date}`, {
        params,
    });
};

export const confirmAll = () => {
    return api.get("/admin/staleorders");
};

export const latasetApi = () => {
    return api.post(`/jobs/orders-sync`);
};
export const uploadExcelApi = ({ file, orderId }: any) => {
    return api.post(`/admin/vendor-dispatch-reports/${orderId}`, file);
};

export const getVendorsInvoice = (params: any) => {
    return api.get(`/admin/vendor-dispatch`, { params });
};

export const downloadWasteTemplate = (params: any) => {
    return api.get(`/admin/vendor-dispatch-template`, { params });
};

export const uploadFileWaste = (body: any) => {
    return api.post(`/admin/vendor-dispatch/upload`, body);
};

export const sendFileWaste = (body: any) => {
    return api.post(`/admin/vendor-dispatch-factor`, body);
};
